(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };
    if(!this.elements.button || !this.elements.panel) return;
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }
  hidePanel(){this.elements.button.setAttribute('aria-expanded','false');this.elements.panel.classList.add('hide');}
  onContainerKeyUp(e){if(e.code.toUpperCase()!=='ESCAPE')return;this.hidePanel();this.elements.button.focus();}
  onItemClick(e){e.preventDefault();const f=this.querySelector('form');this.elements.input.value=e.currentTarget.dataset.value;if(f)f.submit();}
  openSelector(){this.elements.button.focus();this.elements.panel.classList.toggle('hide');this.elements.button.setAttribute('aria-expanded',(this.elements.button.getAttribute('aria-expanded')==='false').toString());}
  closeSelector(e){const s=e.relatedTarget&&e.relatedTarget.nodeName==='BUTTON';if(e.relatedTarget===null||s)this.hidePanel();}
}
customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();
})();
